/**
 * RBAC module slug is `timetable` (UI label: Timetable).
 * Lecture-conversion (lab↔theory) permission slugs. Keep in sync with backend
 * checkPermission() on routes and MyAMSBackend/utils/permissionSeeds.js.
 */

export const TIMETABLE_CONVERT = "timetable.convert";
export const TIMETABLE_CONVERT_OWN = "timetable.convert_own";
export const TIMETABLE_CONVERT_VIEW = "timetable.convert_view";

/**
 * Any of these grants visibility of conversion actions. Own-scoped users
 * (`timetable.convert_own`) act only on their own slots — enforced by backend.
 */
export const TIMETABLE_CONVERSION_PERMISSIONS = [
  TIMETABLE_CONVERT,
  TIMETABLE_CONVERT_OWN,
  TIMETABLE_CONVERT_VIEW,
];
